__turbopack_context__.v({
  "iconGridContainer": "IconGrid-module-scss-module__T7zE5G__iconGridContainer",
  "iconGridHeading": "IconGrid-module-scss-module__T7zE5G__iconGridHeading",
  "iconGridItem": "IconGrid-module-scss-module__T7zE5G__iconGridItem",
  "iconGridItemWrapper": "IconGrid-module-scss-module__T7zE5G__iconGridItemWrapper",
});
